import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useInvalidateQueries } from 'src/api/APIHooks';
import FeatureFlagContainer from 'src/common/utils/FeatureFlags/FeatureFlagContainer';
import { Button, Icon, Modal, Popover } from '@unite-us/app-components';
import CaseCloseForm from './CaseCloseForm';

const ReopenWarning = () => (
  <div className="mb-4 mt-2 font-regular-font" data-testid="reopen-warning">
    <div className="flex items-start p-3 color-background--cloud-blue-color">
      <Icon
        icon="ExclamationCircle"
        size={17}
        className="mr-2 fill-current text-text-blue"
        color="text-blue"
        ariaLabel="note"
      />
      <p className="italic">
        After you close this case, you will not be able to reopen the case
        or submit contracted service notes for the remaining unutilized funds/units.
      </p>
    </div>
  </div>
);

const CaseCloseWrapper = (props) => {
  const closeCaseRef = useRef(null);
  const invalidateQueries = useInvalidateQueries();

  const openDialog = () => {
    closeCaseRef.current.openModal();
  };

  const closeDialog = () => {
    closeCaseRef.current.closeModal();
  };

  const { contact, serviceCase, programHasCap } = props;
  const isPendingAuth = serviceCase?.state === 'pending_authorization';

  return (
    <div className="detail-service-type" data-testid="case-close-wrapper">
      {isPendingAuth ? (
        <Popover
          content={(
            <div
              style={{
                width: '350px',
                height: '22px',
                padding: '4px 10px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              This case is pending authorization and cannot be closed.
            </div>
          )}
          id="hover-popover"
          trigger="hover"
          position="top"
          className="p-0"
        >
          <Button
            id="reopen-btn"
            onClick={openDialog}
            label="Close Case"
            disabled
            primary
            data-testid={'reopen-case-btn-disabled'}
          />
        </Popover>
      ) : (
        <Button
          id="close-case-btn"
          primary
          onClick={openDialog}
          label="Close Case"
        />
      )}
      <Modal
        id="close-case-modal"
        title="Close case"
        data-testid="close-case-modal"
        size="large"
        modal
        showBorderRadius
        ref={closeCaseRef}
      >
        {programHasCap && <ReopenWarning />}
        <CaseCloseForm
          serviceCase={serviceCase}
          contact={contact}
          closeDialog={closeDialog}
          invalidateQueries={invalidateQueries}
        />
      </Modal>
    </div>
  );
};

CaseCloseWrapper.propTypes = {
  serviceCase: PropTypes.object.isRequired,
  contact: PropTypes.object.isRequired,
  programHasCap: PropTypes.bool.isRequired,
};

export default FeatureFlagContainer(CaseCloseWrapper);
